'use strict';

const { h } = require('phy');
const { Translate } = require('@grpn/preact-l10n');

function getMerchantList(routes, merchants) {
  return merchants.map(merchant =>
    h(
      'li.main-menu-dropdown-item',
      h(
        'a.main-menu-dropdown-link',
        {
          href: routes.merchant.show.replace(
            '{merchantSlug}',
            merchant.merchantSlug
          ),
          'data-bhc': `store:${merchant.merchantSlug}`,
        },
        merchant.merchantName,
        h('span.main-menu-dropdown-icon.icon-arrow-right-large')
      )
    )
  );
}

function MerchantsDropdown(routes, showMerchants, merchants = []) {
  const merchantsList = getMerchantList(routes, merchants);

  return h(
    `.main-menu-dropdown.${showMerchants ? 'main-menu-dropdown-show' : ''}`,
    {
      'data-bhw': 'MenuPopularStores',
    },
    [
      h('ul.main-menu-dropdown-list', merchantsList),
      h(
        'a.main-menu-dropdown-link.view-all',
        {
          href: routes.all_brands.main,
        },
        [
          h(Translate, 'js.modules.header.ViewAllMerchants'),
          h(
            'span.main-menu-dropdown-icon.view-all-icon.icon-arrow-right-large'
          ),
        ]
      ),
    ]
  );
}

module.exports = MerchantsDropdown;
